module.exports = __webpack_public_path__ + "media/images/emblems/Sonceboz_Sombeval-coat_of_arms-c855d78e1774a5ff3af5bd5fe083e310.svg";